/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreateBulkEnrollmentRequest
 */
export interface CreateBulkEnrollmentRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof CreateBulkEnrollmentRequest
     */
    studentId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Array<ApiUserTasksGetPageParameter>}
     * @memberof CreateBulkEnrollmentRequest
     */
    classIds: Array<ApiUserTasksGetPageParameter>;
}

/**
 * Check if a given object implements the CreateBulkEnrollmentRequest interface.
 */
export function instanceOfCreateBulkEnrollmentRequest(value: object): value is CreateBulkEnrollmentRequest {
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    if (!('classIds' in value) || value['classIds'] === undefined) return false;
    return true;
}

export function CreateBulkEnrollmentRequestFromJSON(json: any): CreateBulkEnrollmentRequest {
    return CreateBulkEnrollmentRequestFromJSONTyped(json, false);
}

export function CreateBulkEnrollmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBulkEnrollmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'studentId': ApiUserTasksGetPageParameterFromJSON(json['studentId']),
        'classIds': ((json['classIds'] as Array<any>).map(ApiUserTasksGetPageParameterFromJSON)),
    };
}

export function CreateBulkEnrollmentRequestToJSON(json: any): CreateBulkEnrollmentRequest {
    return CreateBulkEnrollmentRequestToJSONTyped(json, false);
}

export function CreateBulkEnrollmentRequestToJSONTyped(value?: CreateBulkEnrollmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'studentId': ApiUserTasksGetPageParameterToJSON(value['studentId']),
        'classIds': ((value['classIds'] as Array<any>).map(ApiUserTasksGetPageParameterToJSON)),
    };
}

